import AccountBanner from "components/AccountBanner";
import Signin from "components/Signin";
import React from "react";

const Login = () => {
  return (
    <div className="flex fixed w-[100vw] justify-between">
      <Signin />
      <AccountBanner />
    </div>
  );
};

export default Login;
